// extracted by mini-css-extract-plugin
module.exports = {"create_admin":"useradmin_create_admin__Hue8J","wrapper":"useradmin_wrapper__2n1Jn"};